import { App, Typography } from "@nokia-csf-uxr/ccfk";
import { Body } from "Components/Body";
import Header from "Components/Header";
import { useAuthState } from "Components/Logics/ensoCommonFunctions";
import React, { memo } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useSelector } from "react-redux";
import error403Image from '../Assets/Icons/Error-403.svg';
import indexStyles from "../Pages/marketplace/Style/Index.module.css"

import { RootState } from "Store/mainStore";

const Unauthorized = () => {
  const authSelector = useSelector((state: RootState) => state.authSlice);
  useAuthState();
  return (
    <>
      <LoadingOverlay
        active={authSelector.system.isLoading}
        spinner
        classNamePrefix="MyLoader_"
        text="Please wait "
      >
        <App>
          <Header />
          <div className="access-denied-wrapper">
            <div className="access-denied-content">
              <p style={{textAlign:'center'}}><img src={error403Image} alt="403-Error" className={indexStyles.imgFluid}/></p>
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <h5 style={{ fontSize: '16px', fontWeight: 'bold', marginBlockStart: '0', marginBlockEnd: '0', marginBottom: '.5rem', textAlign: 'center' }}>403 - Restricted user access</h5>
                <Typography style={{color:'#333333'}}>Sorry, the page you are looking for has restricted access, please</Typography>
                <Typography style={{color:'#333333'}}>send a mail to [<a href="mailto:da.tools@nokia.com">da.tools@nokia.com</a>] for access</Typography>
            </div> 
            </div>
          </div>
        </App>
        {/* <AppFooter /> */}
      </LoadingOverlay>
    </>
  );
};
export default Unauthorized;
